import React from 'react';
import { Clock, ChevronDown } from 'lucide-react';

const TestHistory = ({ testHistory, showHistory, setShowHistory }) => {
  return (
    <div className="glass-card rounded-2xl p-6 bg-white dark:bg-gray-800 border border-[#1E9B4C]/20 dark:border-green-500/20">
      <div 
        className="flex items-center justify-between cursor-pointer mb-4"
        onClick={() => setShowHistory(!showHistory)}
      >
        <h3 className="font-bold text-lg flex items-center text-[#1E9B4C] dark:text-green-400">
          <Clock className="w-5 h-5 mr-2" />
          History
        </h3>
        <ChevronDown 
          className={`w-5 h-5 transition-transform text-[#1E9B4C] dark:text-green-400 ${showHistory ? 'rotate-180' : ''}`}
        />
      </div>
      
      {showHistory && (
        <div className="space-y-3 max-h-64 overflow-y-auto">
          {testHistory.length === 0 ? (
            <p className="text-gray-600 dark:text-gray-400 text-sm text-center py-4">
              No test history yet
            </p>
          ) : (
            testHistory.map((test) => (
              <div key={test.id} className="bg-gray-100 dark:bg-gray-700/50 rounded-lg p-3 border border-[#1E9B4C]/10 dark:border-green-500/10">
                <div className="flex justify-between items-center mb-1">
                  <span className="text-xs text-gray-600 dark:text-gray-400">{test.timestamp}</span>
                  <span className="text-xs text-[#1E9B4C] dark:text-green-400">{test.server}</span>
                </div>
                <div className="flex justify-between text-sm">
                  <span className="text-[#1E9B4C] dark:text-green-400">↓ {test.downloadSpeed.toFixed(1)} Mbps</span>
                  <span className="text-[#1E9B4C] dark:text-green-400">↑ {test.uploadSpeed.toFixed(1)} Mbps</span>
                  <span className="text-[#1E9B4C] dark:text-green-400">{test.ping.toFixed(0)}ms</span>
                </div>
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
};

export default TestHistory;